import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { AudienceSection } from '../components/AudienceSection';
import { ProcessSection } from '../components/ProcessSection';
import { FAQSection } from '../components/FAQSection';
import { OfferSection } from '../components/OfferSection';
import { FooterSection } from '../components/FooterSection';
export function SalesPage() {
  return <div className="min-h-screen w-full bg-[#0f1629]" data-id="element-287">
      <HeroSection data-id="element-288" />
      <ProblemSection data-id="element-289" />
      <SolutionSection data-id="element-290" />
      <AudienceSection data-id="element-291" />
      <ProcessSection data-id="element-292" />
      <FAQSection data-id="element-293" />
      <OfferSection data-id="element-294" />
      <FooterSection data-id="element-295" />
    </div>;
}